import { render, staticRenderFns } from "./PrestigeInventory.vue?vue&type=template&id=4c459e3c&scoped=true"
import script from "./PrestigeInventory.vue?vue&type=script&lang=js"
export * from "./PrestigeInventory.vue?vue&type=script&lang=js"
import style0 from "./PrestigeInventory.vue?vue&type=style&index=0&id=4c459e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c459e3c",
  null
  
)

export default component.exports